import { Col, Divider, Input, Row, Space } from "antd";
import FB from "assets/logo/facebook.png";
import INSTA from "assets/logo/instagram.png";
import INTERNET from "assets/logo/internet.png";
import LINE from "assets/logo/line.png";
import TT from "assets/logo/tiktok.png";
import TWT from "assets/logo/twitter.png";

import styles from "./ContactInfo.module.css";
import { useTranslation } from "react-i18next";
import { FormInput } from "components/form/FormProvide";

const ContactInfoForEdit = ({ lower = null }) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" size={6}>
      <b className={styles.infoTopic}>
        {t("company_profile.label.contact_information")}
      </b>
      <Divider />
      <Row gutter={[24, 16]}>
        <Col span={12}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            numberOnly={true}
            name="telNo"
            label={
              t("company_profile.label.tel_no")
            }
            placeholder={t('company_profile.label.tel_no_holder')}
            size="large"
          />
        </Col>
        <Col span={12}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            required
            numberOnly={true}
            name="phoneNo"
            label={
              t("company_profile.label.phone_no")
            }
            placeholder={t("company_profile.label.phone_no")}
            size="large"
          // rules={[
          //   ({ getFieldValue }) => ({
          //     validator(_, value) {
          //       if (value.length == 13) {
          //         return Promise.resolve();
          //       }
          //       return Promise.reject(new Error('invalid format length 13'));
          //     },
          //   }),
          // ]}
          />
        </Col>
        <Col span={12}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            required
            name="email"
            label={
              t("company_profile.label.email")
            }
            placeholder={t('company_profile.label.e_mail_holder')}
            size="large"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value.match("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$")) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('invalid format Email'));
                },
              }),
            ]}
          />
        </Col>
        <Col span={12}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            name="faxNo"
            numberOnly={true}
            label={
              t("company_profile.label.fax")
            }
            placeholder={t('company_profile.label.fax_holder')}
            size="large"
          />
        </Col>
      </Row>
      {/* <div className={styles.socialInfo}>
        <b className={styles.infoTopic}>
          {t("company_profile.label.social_media_information")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={FB} alt="Facebook logo" />
            </div>
            <FormInput fontWeight="bold" vertical={true} name="facebook" placeholder="Facebook" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={TWT} alt="x logo" />
            </div>
            <FormInput fontWeight="bold" vertical={true} name="x" placeholder="Twitter" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img
                className={styles.socialLogo}
                src={INSTA}
                alt="Instagram logo"
              />
            </div>
            <FormInput fontWeight="bold" vertical={true} name="instagram" placeholder="Instargram" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={TT} alt="Tiktok logo" />
            </div>
            <FormInput fontWeight="bold" vertical={true} name="tiktok" placeholder="Tiktok" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={LINE} alt="Line logo" />
            </div>
            <FormInput fontWeight="bold" vertical={true} name="lineId" placeholder="Line OA" size="large" />
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img
                className={styles.socialLogo}
                src={INTERNET}
                alt="Internet logo"
              />
            </div>
            <FormInput fontWeight="bold" vertical={true} name="website" placeholder="Website" size="large" />
          </Col>
        </Row>
      </div> */}
      {lower}
    </Space>
  );
};

export default ContactInfoForEdit;
